/*
 common/actions

 usage:
 var actions = require('../../common/lib/dataflow').actions();

 var actions = require('../common/actions');
 Naming-convention: modulenameExtension ....function...type...constants.MODULENAME_EXTENSION

 actions.createMyAction(some,data);

 When the action is invoked the dispatcher invokes all callbacks with the provided type and arguments.

 */
import {dispatch} from './dispatcher.js';
import constants from './constants.js';

function check() {
	/* verify that constants that will be used also exists and are defined */
	const used0 = ['BONUSES', 'CANCEL_WITHDRAW_FAIL_NOTIFICATION', 'FEE', 'FETCH_AMOUNTS', 'FETCH_BONUSES', 'FETCH_BONUSES_FREE_MONEY_BONUS_SUCCESS', 'FETCH_CANCEL_WITHDRAW', 'FETCH_FEES_AND_LIMITS'];
	const used1 = ['FETCH_FEES_AND_LIMITS', 'FETCH_METHODDETAILS', 'FETCH_PAYMENTMETHODS', 'FETCH_PENDING_WITHDRAWALS'];
	const used2 = ['SETUP_BONUS', 'PENDING_WITHDRAWALS', 'RESULT_AFTER_SINGLE_CALL', 'SETUP_PAYMENT', 'SETUP_PENDING_WITHDRAWALS', 'SUBMIT_PAYMENT', 'TEST_PURPOSE'];
	const used3 = ['VIEW', 'VIEW_AMOUNTINPUT', 'VIEW_BONUS', 'VIEW_CURRENCYSELECT', 'VIEW_CREDITCARDLAST', 'VIEW_PENDING_WITHDRAWALS', 'VIEW_CREDITCARD', 'VIEW_METHODS', 'VIEW_NAV'];
	const used4 = ['VIEW_PAYMENTFORM_SUBMIT', 'VIEW_UK_FIRST_TIME_DEPOSIT_LINK', 'VIEW_AMOUNTSELECT'];
	const used = used0.concat(used1, used2, used3, used4);

	used.forEach((key) => {
		if (constants.hasOwnProperty && !{}.hasOwnProperty.call(constants, key)) {
			console.error(`payment/common/utils/actions:28:check: constant does not exist:${key}`);
			return;
		}
	});
}
check();

export default {
	asynchronousResultAfterSingleCall(paymentHandled) {
		dispatch({
			type: constants.ASYNCHRONOUS_RESULT_AFTER_SINGLE_CALL,
			paymentHandled
		});
	},
	bonuses(data) {
		dispatch({
			type: constants.BONUSES,
			data
		});
	},
	fee(data) {
		dispatch({
			type: constants.FEE,
			data
		});
	},
	fetchAmounts(data) {
		dispatch({
			type: constants.FETCH_AMOUNTS,
			data
		});
	},
	fetchBonuses(data) {
		dispatch({
			type: constants.FETCH_BONUSES,
			data
		});
	},
	fetchBonusesFreeMoneyBonusSuccess(data) {
		dispatch({
			type: constants.FETCH_BONUSES_FREE_MONEY_BONUS_SUCCESS,
			data
		});
	},
	fetchBonusesForShopDeposit(data, selectedBonusId, bonusPaymentMethods) {
		dispatch({
			type: constants.FETCH_BONUSES_FOR_SHOP_DEPOSIT,
			data,
			selectedBonusId,
			bonusPaymentMethods
		});
	},
	fetchCancelWithdraw(data) {
		dispatch({
			type: constants.FETCH_CANCEL_WITHDRAW,
			data
		});
	},
	fetchFeesAndLimits(data) {
		dispatch({
			type: constants.FETCH_FEES_AND_LIMITS,
			data
		});
	},
	validateFeesAndLimitsAtSubmit(data) {
		dispatch({
			type: constants.VALIDATE_FEES_AND_LIMITS_AT_SUBMIT,
			data
		});
	},
	fetchMethodDetails(data) {
		dispatch({
			type: constants.FETCH_METHODDETAILS,
			data
		});
	},
	fetchPaymentmethods(data) {
		dispatch({
			type: constants.FETCH_PAYMENTMETHODS,
			data
		});
	},
	fetchPendingWithdrawals(data) {
		dispatch({
			type: constants.FETCH_PENDING_WITHDRAWALS,
			data
		});
	},
	resultAfterSingleCall(paymentHandled) {
		dispatch({
			type: constants.RESULT_AFTER_SINGLE_CALL,
			paymentHandled
		});
	},
	paymentmethods(data) {
		dispatch({
			type: constants.PAYMENTMETHODS,
			data
		});
	},
	pendingWithdrawals(data) {
		dispatch({
			type: constants.PENDING_WITHDRAWALS,
			data
		});
	},
	reloadBonuses() {
		dispatch({
			type: constants.RELOAD_BONUSES
		});
	},
	reloadBonusesAfterFreeMoneyBonusSuccess() {
		dispatch({
			type: constants.RELOAD_BONUSES_FREE_MONEY_BONUS_SUCCESS
		});
	},
	setupBonus() {
		dispatch({
			type: constants.SETUP_BONUS
		});
	},
	setupPayment() {
		dispatch({
			type: constants.SETUP_PAYMENT
		});
	},
	setupPendingWithdrawals() {
		dispatch({
			type: constants.SETUP_PENDING_WITHDRAWALS
		});
	},
	shopHandleBonusForDeposit(data) {
		dispatch({
			type: constants.SHOP_HANDLE_BONUS_FOR_DEPOSIT,
			data
		});
	},
	submitPayment(p) {
		dispatch({
			type: constants.SUBMIT_PAYMENT,
			sendHandlerData: p.sendHandlerData,
			accHistRef: p.accHistRef,
			paymentFetchResultFlow: p.paymentFetchResultFlow,
			sendHandlerType: p.sendHandlerType,
			success: p.success
		});
	},
	testPurpose(data) {
		/* during setup of tests */
		// console.log('actions:testPurposeAction');
		dispatch({
			type: constants.TEST_PURPOSE,
			data
		});
	},
	view(data) {
		dispatch({
			type: constants.VIEW,
			data
		});
	},
	viewAmountInput(data) {
		dispatch({
			type: constants.VIEW_AMOUNTINPUT,
			data
		});
	},
	viewAmountselect(data) {
		dispatch({
			type: constants.VIEW_AMOUNTSELECT,
			data
		});
	},
	viewBonus(data) {
		dispatch({
			type: constants.VIEW_BONUS,
			data
		});
	},
	viewBonusFromShop(data) {
		dispatch({
			type: constants.VIEW_BONUS_FROM_SHOP,
			data
		});
	},
	viewCurrencySelect(data) {
		dispatch({
			type: constants.VIEW_CURRENCYSELECT,
			data
		});
	},
	viewCreditcard(data) {
		dispatch({
			type: constants.VIEW_CREDITCARD,
			data
		});
	},
	viewCreditCardNew(data) {
		dispatch({
			type: constants.VIEW_CREDITCARDNEW,
			data
		});
	},
	viewCreditcardlast(data) {
		dispatch({
			type: constants.VIEW_CREDITCARDLAST,
			data
		});
	},
	viewUkFirstTimeDepositLink(data) {
		dispatch({
			type: constants.VIEW_UK_FIRST_TIME_DEPOSIT_LINK,
			data
		});
	},
	viewNav(p) { /* TODO: this will probably not be used when router.js is replaced by react-router navigation. See 'nav_withdrawal' folder. */
		dispatch({
			type: constants.VIEW_NAV,
			skip: p.skip,
			back: p.back,
			close: p.close
		});
	},
	viewMethods(methodId, methodText) {
		dispatch({
			type: constants.VIEW_METHODS,
			id: methodId,
			text: methodText
		});
	},
	viewPaymentform(data) {
		dispatch({
			type: constants.VIEW_PAYMENTFORM,
			data
		});
	},
	viewPaymentformSubmit(formdata) {
		dispatch({
			type: constants.VIEW_PAYMENTFORM_SUBMIT,
			data: formdata
		});
	},
	viewPaymentMethodLink(data) {
		dispatch({
			type: constants.VIEW_PAYMENT_METHOD_LINK,
			data
		});
	},
	viewPendingWithdrawals(data) {
		dispatch({
			type: constants.VIEW_PENDING_WITHDRAWALS,
			data
		});
	},
	cancelWithDrawFailNotification(data) {
		dispatch({
			type: constants.CANCEL_WITHDRAW_FAIL_NOTIFICATION,
			data
		});
	},
	viewSelectSkrillAccount(data) {
		dispatch({
			type: constants.VIEW_SELECT_SKRILL_ACCOUNTING,
			data
		});
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/common/lib/utils/actions.js